export default __webpack_public_path__ + "static/assets/3e0accd769c45aecce7f1bbf107f98e4.png";